module.exports = __webpack_public_path__ + "img/research-img.e39f3e13.jpg";